import { useState } from 'react'

import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '../ui/dialog'
import { ContactUsForm } from './contact-us-form'

export function ContactUs({ className }: { className?: string }) {
	const [open, setOpen] = useState(false)

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger className={className}>Kontakt</DialogTrigger>
			<DialogContent
				onInteractOutside={(e) => e.stopPropagation()}
				className="mx-auto"
			>
				<DialogHeader>
					<DialogTitle className="text-left">Kontaktieren Sie uns</DialogTitle>
					<ContactUsForm setOpen={setOpen} />
				</DialogHeader>
			</DialogContent>
		</Dialog>
	)
}
